module.exports = __webpack_public_path__ + "assets/c43033f002ec2d864c5aca6f45cea25c.mp3";